import React, { useState, useEffect, useCallback } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { getArticles, getCategories } from '../api';

function BlogList() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [articles, setArticles] = useState([]);
    const [categories, setCategories] = useState([]);
    const [pagination, setPagination] = useState({ page: 1, totalPages: 1 });
    const [loading, setLoading] = useState(true);

    const currentCategory = searchParams.get('category') || '';
    const currentPage = parseInt(searchParams.get('page')) || 1;

    const loadData = useCallback(async () => {
        setLoading(true);
        try {
            const [articlesRes, categoriesRes] = await Promise.all([
                getArticles({ category: currentCategory || undefined, page: currentPage }),
                getCategories()
            ]);
            setArticles(articlesRes.data.articles);
            setPagination(articlesRes.data.pagination);
            setCategories(categoriesRes.data);
        } catch (err) {
            console.error('Error loading data:', err);
        } finally {
            setLoading(false);
        }
    }, [currentCategory, currentPage]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const handleCategoryChange = (category) => {
        const params = new URLSearchParams();
        if (category) params.set('category', category);
        setSearchParams(params);
    };

    const handlePageChange = (page) => {
        const params = new URLSearchParams(searchParams);
        params.set('page', page.toString());
        setSearchParams(params);
    };

    return (
        <>
            {/* Hero Header */}
            <div className="blog-hero" style={{ backgroundImage: 'url(/hero-bg.jpg)' }}>
            </div>

            <div className="blog-container">
                <header className="blog-header">
                    {categories.length > 0 && (
                        <div className="category-filters">
                            <button
                                className={`category-tag ${!currentCategory ? 'active' : ''}`}
                                onClick={() => handleCategoryChange('')}
                            >
                                Tutti
                            </button>
                            {categories.map(cat => (
                                <button
                                    key={cat}
                                    className={`category-tag ${currentCategory === cat ? 'active' : ''}`}
                                    onClick={() => handleCategoryChange(cat)}
                                >
                                    {cat}
                                </button>
                            ))}
                        </div>
                    )}
                </header>

                {loading ? (
                    <div className="loading">Caricamento...</div>
                ) : articles.length === 0 ? (
                    <div className="no-articles">
                        <p>Nessun articolo disponibile al momento.</p>
                    </div>
                ) : (
                    <>
                        <div className="articles-grid">
                            {articles.map(article => (
                                <article key={article.id} className="article-card">
                                    <Link to={`/blog/${article.slug}`} className="article-link">
                                        <div className="article-image-wrapper">
                                            {article.cover_image_url ? (
                                                <img
                                                    src={`${article.cover_image_url}`}
                                                    alt={article.title}
                                                    className="article-image"
                                                    loading="lazy"
                                                />
                                            ) : (
                                                <div className="article-image-placeholder">
                                                    <span>Evomotor</span>
                                                </div>
                                            )}
                                        </div>
                                        <div className="article-content">
                                            {article.category && (
                                                <span className="article-category">{article.category}</span>
                                            )}
                                            <h2 className="article-title">{article.title}</h2>
                                        </div>
                                    </Link>
                                </article>
                            ))}
                        </div>

                        {pagination.totalPages > 1 && (
                            <nav className="pagination">
                                <button
                                    className="pagination-btn"
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    disabled={currentPage <= 1}
                                >
                                    ← Precedente
                                </button>
                                <span className="pagination-info">
                                    Pagina {pagination.page} di {pagination.totalPages}
                                </span>
                                <button
                                    className="pagination-btn"
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    disabled={currentPage >= pagination.totalPages}
                                >
                                    Successiva →
                                </button>
                            </nav>
                        )}
                    </>
                )}
            </div>
        </>
    );
}

export default BlogList;
